var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.222,
    height: 32,
    viewBox: "0 0 30.222 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.678 17.072h10.074c0.924 0 1.68 -0.756 1.68 -1.68V1.96a1.684 1.684 0 0 0 -1.68 -1.68H1.678A1.684 1.684 0 0 0 0 1.96v13.432c0 0.924 0.756 1.68 1.678 1.68Zm16.79 13.432h10.074a1.684 1.684 0 0 0 1.678 -1.678V15.392a1.684 1.684 0 0 0 -1.678 -1.678H18.468a1.684 1.684 0 0 0 -1.68 1.678v13.432c0 0.924 0.756 1.678 1.68 1.678Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.678 30.502h10.074c0.924 0 1.68 -0.756 1.68 -1.678v-6.716a1.684 1.684 0 0 0 -1.68 -1.678H1.678a1.684 1.684 0 0 0 -1.678 1.678v6.716c0 0.924 0.756 1.678 1.678 1.678ZM16.79 1.96v6.716c0 0.924 0.756 1.68 1.68 1.68h10.074a1.684 1.684 0 0 0 1.678 -1.68V1.96a1.684 1.684 0 0 0 -1.678 -1.68H18.47a1.684 1.684 0 0 0 -1.68 1.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f9723543.svg";
export { ForwardRef as ReactComponent };